import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
import { useSearchResultsQuery } from '../hooks/useSearchResultsQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsHeader() {
  var _data$result$total;
  const searchParams = useSearchParams();
  const {
    data
  } = useSearchResultsQuery();
  if (!searchParams.get('search')) return undefined;
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    blockSize: "40px",
    flexShrink: 0,
    children: /*#__PURE__*/_jsx(Text, {
      as: "h1",
      typography: "body-200",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "marketplaceStorefront.searchResults.header.resultsForQuery_jsx",
        elements: {
          Strong: props => /*#__PURE__*/_jsx(Text, Object.assign({
            as: "span",
            typography: "heading-100"
          }, props))
        },
        options: {
          count: (_data$result$total = data === null || data === void 0 ? void 0 : data.result.total) !== null && _data$result$total !== void 0 ? _data$result$total : 0,
          query: searchParams.get('search')
        }
      })
    })
  });
}